import { Logo } from "@paribus/shared-ui";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";

import { useAuth } from "../contexts/AuthContext";
import { invalidateCasesCache, updateCaseInCache } from "../hooks/useCases";
import { useCreateCase } from "../hooks/useCreateCase";
import { useIsMobile } from "../hooks/useIsMobile";
import "../styles/Layout.css";
import { CreditBalance } from "./CreditBalance/CreditBalance";
import { FirmMenu } from "./FirmMenu/FirmMenu";
import MobileChrome from "./MobileChrome";
import UserMenu from "./UserMenu/UserMenu";

const Layout = () => {
  const [selectedCase, setSelectedCase] = useState("");
  const [isCreatingCase, setIsCreatingCase] = useState(false);
  const isMobile = useIsMobile(768);

  const { caseId: urlCaseId } = useParams();
  const { createCase } = useCreateCase();

  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const caseId = new URLSearchParams(location.search).get("caseId");
    if (caseId) {
      setSelectedCase(caseId);
    }
  }, [location]);

  const handleNewCase = async () => {
    if (isCreatingCase) return;

    setIsCreatingCase(true);
    try {
      const caseData = await createCase();
      if (!caseData) return;

      invalidateCasesCache();
      setSelectedCase(caseData.case.case_id);
      navigate(`/cases/${caseData.case.case_id}/files`);
    } finally {
      setIsCreatingCase(false);
    }
  };

  const handleCaseNameUpdate = (updatedCaseId, newCaseName) => {
    updateCaseInCache(updatedCaseId, { case_name: newCaseName });
  };

  useEffect(() => {
    if (urlCaseId) {
      setSelectedCase(urlCaseId);
    }
  }, [urlCaseId]);

  return (
    <div className={isMobile ? "mobile-layout" : "layout"}>
      {isMobile && (
        <MobileChrome
          selectedCase={selectedCase}
          setSelectedCase={setSelectedCase}
          handleNewCase={handleNewCase}
        />
      )}
      {!isMobile && (
        <nav className="top-nav">
          <div className="nav-left">
            <Logo />
          </div>
          <div className="nav-right">
            {user && (
              <>
                <CreditBalance />
                <FirmMenu />
                <UserMenu />
              </>
            )}
          </div>
        </nav>
      )}

      <div className={isMobile ? "mobile-content-outer" : "main-content"}>
        <main className={isMobile ? "mobile-content" : "content"}>
          <Outlet context={{ onCaseNameUpdate: handleCaseNameUpdate }} />
        </main>
      </div>
    </div>
  );
};

export default Layout;
